import { figmaColors } from '@doltech/ui/lib/figma/colors';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { deviceBreakpoints } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import styled from 'styled-components';
import { HEADER_HEIGHT_DO_TEST_DESKTOP } from '../mobile/DoTest/Reading/Header/DoTestHeaderDesktop';

export const ReadingTestLayout = styled.section<{ expanded?: boolean }>`
  height: 100%;
  background: linear-gradient(
    to right,
    ${colorsV2.white100} calc((100vw - 1680px) / 2),
    ${colorsV2.gray10} calc(((100vw - 1680px) / 2) + 1px)
  );
  .content-wrapper {
    height: 100%;

    display: grid;
    grid-template-columns: 5fr 7fr;

    margin: 0 auto;
    @media ${deviceBreakpoints.fromLgDesktop} {
      max-width: 1680px;
    }
  }

  @media ${deviceBreakpoints.tablet} {
    .content-wrapper {
      padding-top: ${HEADER_HEIGHT_DO_TEST_DESKTOP - 12}px;
    }
    &#test-result-container {
      .content-wrapper {
        padding-top: 0;
      }
    }
  }

  #sidebar-left {
    background: ${figmaColors.W2B1};
    box-shadow: 4px 4px 4px ${figmaColors.boxShadow};
    padding: 16px 24px;
    position: relative;
    transition: all 0.3s ease;
    overflow-y: auto;
  }

  #body-container {
    flex: 1;
    overflow: auto;
    transition: all 0.3s ease;
    overflow-y: auto;
  }
`;
